<template>
  <PageLayout>
    <template #header>
      <div></div>
    </template>
    <div class="min-h-screen bg-secondary">
      <div class="mobile-status-padding"></div>

    <VBusHelper
      :emitOnMounted="$constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH"
    />
      <div class="p-6">
        <!-- <div class="flex justify-between">
          <div class="w-8 h-8">
            <ColorImg class="bg-white" />
          </div>
          <div class="w-8 h-8">
            <ColorImg class="bg-white" />
          </div>
        </div> -->

        <div class="grid grid-cols-4 mt-6 gap-4 items-center">
          <div class="">
            <div class="py-[50%] relative">
              <div class="absolute top-0 left-0 w-full h-full">
                <ImgComponent
                  :src="$stores.user?.state?.current?.email"
                  avatar
                  alt="Profile"
                  class="w-full h-full rounded-full bg-white"
                />
                <div
                  class="absolute -bottom-2 -left-0 w-8 h-8 bg-green-500 rounded-full border-4 border-secondary flex items-center justify-center"
                >
                  <svg
                    class="w-4 h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-3">
            <h2 class="text-3xl text-white mb-1">
              {{ $stores.user?.state?.current?.firstName }}
              {{ $stores.user?.state?.current?.lastName }}
            </h2>
            <p class="text-primary-100 mb-1">
              {{ $stores.user?.state?.current?.email }}
            </p>
          </div>
        </div>

        <p
          class="text-white mb-1 mt-1 rounded-full border border-primary-200 px-5 py-1 text-sm md:text-base w-min whitespace-nowrap"
        >
          {{
            Countries.find($stores.user?.state?.current?.countryCode)
              ?.countryName
          }}
        </p>

        <div class="grid grid-cols-3 mt-6">
          <div class="border-r border-secondary-300">
            <div class="">
              <span class="text-white text-2xl">0 </span>
              <span class="text-primary-300">CFA</span>
            </div>
            <div class="text-primary-300">Bonus</div>
          </div>
          <div class="pl-4">
            <div class="">
              <span class="text-white text-2xl">{{ $stores.transactions?.state?.list_all?.total || 0 }} </span>
            </div>
            <div class="text-primary-300">Transactions</div>
          </div>
          <!-- <div class="pl-4">
            <div class="">
              <span class="text-white text-2xl">420 </span>
            </div>
            <div class="text-primary-300">Recharges</div>
          </div>
          <div class="pl-6">
            <div class="">
              <span class="text-white text-2xl">130 </span>
            </div>
            <div class="text-primary-300">Retraits</div>
          </div> -->
        </div>
      </div>

      <div class="rounded-t-3xl bg-black/10 p-8 relative">
        <div class="text-white/60 relative -top-3 text-xl flex justify-between">
          <div>Badges</div>
          <div>0 / {{ 4 * 5 }}</div>
        </div>
        <div
          class="absolute bottom-2 w-full flex justify-between left-0 duration-500 h-min"
          :class="{
            'top-[70%]': reducedBadges,
            'top-2 rotate-180': !reducedBadges
          }"
          @click="reducedBadges = !reducedBadges"
        >
          <div class="w-5 h-5 mx-auto">
            <ColorImg
              src="/images/icons/right-arrow.svg"
              class="bg-white rotate-90"
            />
          </div>
        </div>
        <div
          class="duration-300 overflow-hidden"
          :class="{
            'max-h-[20vw]': reducedBadges,
            'max-h-[200vh]': !reducedBadges
          }"
        >
          <div class="grid grid-cols-4 gap-6">
            <div v-for="i in 4 * 5">
              <div class="rounded-full p-4 relative opacity-75">
                <ColorImg
                  class="bg-white w-full h-full absolute top-0 left-0"
                  src="/images/badge/background.png"
                />
                <ColorImg
                  class="bg-gray-300 relative"
                  src="/images/badge/badge.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-[#F7F4FF] -mt-4 rounded-t-3xl p-8 relative">
        <div
          class="cursor-pointer"
          v-bus:EVENTS.BOOKMAKER.SELECT_BOOKMAKER_ID_TO_CHANGE.click
        >
          <div class="flex items-center gap-4">
            <div
              class="w-12 h-12 rounded-xl border border-primary flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-primary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                ></path>
              </svg>
            </div>
            <div>
              <p class="text-gray-500 text-sm">Bookmaker IDs</p>
              <p class="text-gray-800 font-bold">Configurer</p>
            </div>
            <svg
              class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors ml-auto mr-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </div>
        </div>

        <h3 class="text-xl text-gray-400 mb-2 mt-8">Aide & Support</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <a
            v-for="(content, i) in contactContents"
            :key="i"
            :href="
              (content.id == 'email' ? 'mailto:' : '') +
              ($stores.appData?.state?.data?.general?.[content.id] || '')
            "
            target="_blank"
            class="flex items-center gap-3 group"
          >
            <div
              class="w-10 h-10 rounded-lg flex items-center justify-center group-hover:bg-gray-50 transition-colors"
            >
              <ImgComponent :src="content.icon" class="w-5 h-5" />
            </div>
            <div class="flex-1">
              <p class="text-gray-800">{{ content.name }}</p>
              <!-- <p class="text-gray-500 text-sm">{{ content.actionText }}</p> -->
            </div>
            <svg
              class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </a>
          <div
            @click="moreHelpModalVisible = true"
            class="flex items-center gap-3 group"
          >
            <div
              class="w-10 h-10 rounded-lg flex items-center justify-center group-hover:bg-gray-50 transition-colors"
            >
              <ImgComponent src="/images/icons/help.svg" class="w-5 h-5" />
            </div>
            <div class="flex-1">
              <p class="text-gray-800">Besoin d'aide ?</p>
              <!-- <p class="text-gray-500 text-sm">Accédez au menu d'aide</p> -->
            </div>
            <svg
              class="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </div>
        </div>

        <h3 class="text-xl text-gray-400 mb-4 mt-8">Réglages Utils</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="flex items-center gap-3 group">
            <div class="flex-1">
              <p class="text-gray-800 font-bold">Notification Whatsapp</p>
              <p class="text-gray-500 text-sm">
                Autorisez les notifications et bonus envoyez par whatsap
              </p>
            </div>
            <label class="switch">
              <input type="checkbox" v-model="enableWhatsapNotf" />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <!-- Logout Button -->
        <div class="text-center mt-8">
          <button
            @click="
              () => {
                $bus.emit($constants.EVENTS.USER.LOGOUT);
                $router.replace('/login');
              }
            "
            class="w-full justify-center inline-flex items-center gap-3 px-8 py-4 text-red-600 rounded-2xl font-bold border border-red-200"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              ></path>
            </svg>
            Déconnexion
          </button>
        </div>
      </div>

      <!-- Help Modal -->
      <Transition name="modal-fullscreen">
        <div
          class="fixed inset-0 z-50 bg-slate-300/50 backdrop-blur-sm"
          v-if="moreHelpModalVisible"
          @click.self="moreHelpModalVisible = false"
        >
          <div class="h-full overflow-auto">
            <div class="min-h-screen p-4 md:p-6">
              <!-- Modal Header -->
              <div class="flex items-center justify-between mb-6">
                <h2 class="text-2xl font-bold text-gray-800">Centre d'aide</h2>
                <button
                  @click="moreHelpModalVisible = false"
                  class="w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-colors"
                >
                  <svg
                    class="w-6 h-6 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>

              <div
                class="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6"
              >
                <!-- Help Section -->
                <div class="bg-white rounded-2xl p-6">
                  <h3 class="text-lg font-bold text-gray-800 mb-4">
                    Aide rapide
                  </h3>
                  <div class="space-y-3">
                    <div
                      v-for="(content, i) in helpContents"
                      :key="i"
                      @click="
                        () => {
                          if (content.id == 'rechargeHelp') rechargeHelpClick();
                          if (content.id == 'withdrawHelp') withdrawHelpClick();
                        }
                      "
                      class="flex items-center gap-3 p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer border border-gray-100"
                    >
                      <ImgComponent :src="content.icon" class="w-6 h-6" />
                      <div class="flex-1">
                        <p class="text-gray-800 font-bold">
                          {{ content.name }}
                        </p>
                        <p class="text-gray-500 text-sm">
                          {{ content.actionText }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Networks Section -->
                <div class="bg-white rounded-2xl p-6">
                  <h3 class="text-lg font-bold text-gray-800 mb-4">
                    Suivez-nous
                  </h3>
                  <div class="space-y-3">
                    <a
                      v-for="(content, i) in networksContents"
                      :key="i"
                      :href="
                        $stores.appData?.state?.data?.general?.[content.id] ||
                        ''
                      "
                      target="_blank"
                      class="flex items-center gap-3 p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors border border-gray-100"
                    >
                      <ImgComponent :src="content.icon" class="w-6 h-6" />
                      <div class="flex-1">
                        <p class="text-gray-800 font-bold">
                          {{ content.name }}
                        </p>
                        <p class="text-gray-500 text-sm">
                          {{ content.actionText }}
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <!-- Apps Section -->
              <div class="max-w-4xl mx-auto mt-6">
                <div class="bg-white rounded-2xl p-6">
                  <h3 class="text-lg font-bold text-gray-800 mb-4">
                    Applications
                  </h3>
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <a
                      v-for="(content, i) in appsContents"
                      :key="i"
                      :href="$stores.appData?.state?.data?.[content.id] || ''"
                      target="_blank"
                      class="flex flex-col items-center gap-3 p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors border border-gray-100"
                    >
                      <ImgComponent :src="content.icon" class="w-12 h-12" />
                      <p class="text-gray-800 text-sm text-center font-bold">
                        {{ content.name }}
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </PageLayout>
</template>

<script>
import { defineComponent } from 'vue';
import { Countries } from '../shared/libraries/countries';

export default defineComponent({
  name: 'ProfilePage',
  components: {},
  setup() {
    return { Countries };
  },
  data() {
    return {
      reducedBadges: true,
      moreHelpModalVisible: false,
      enableWhatsapNotf: false,
      userCountry: {},
      contactContents: [
        {
          id: 'whatsappAssistanceLink',
          name: 'Whatsapp',
          icon: '/images/icons/whatsapp.svg',
          actionText: 'Contacter'
        },
        {
          id: 'telegramAssistanceLink',
          name: 'Telegram',
          icon: '/images/icons/telegram_1.svg',
          actionText: 'Contacter'
        },
        {
          id: 'email',
          name: 'Email',
          icon: '/images/icons/email.svg',
          actionText: 'Envoyer'
        }
      ],
      networksContents: [
        {
          id: 'whatsappLink',
          name: 'Whatsapp',
          icon: '/images/icons/whatsapp.svg',
          actionText: 'Suivre'
        },
        {
          id: 'telegramLink',
          name: 'Telegram',
          icon: '/images/icons/telegram_1.svg',
          actionText: 'Suivre'
        },
        {
          id: 'instagramLink',
          name: 'Instagram',
          icon: '/images/icons/instagram_1.svg',
          actionText: 'Suivre'
        },
        {
          id: 'facebookLink',
          name: 'Facebook',
          icon: '/images/icons/facebook-app-symbol.svg',
          actionText: 'Suivre'
        },
        {
          id: 'tiktokLink',
          name: 'TikTok',
          icon: '/images/icons/tik-tok.svg',
          actionText: 'Suivre'
        },
        {
          id: 'websiteLink',
          name: 'Site Web',
          icon: '/images/icons/www.svg',
          actionText: 'Visiter'
        }
      ],
      helpContents: [
        {
          id: 'faqUrl',
          isLink: true,
          name: 'F.A.Q.',
          icon: '/images/icons/help.svg',
          actionText: 'Visiter'
        },
        {
          id: 'rechargeHelp',
          isLink: false,
          name: 'Comment faire un dépot ?',
          icon: '/images/icons/help.svg',
          actionText: 'Voir'
        },
        {
          id: 'withdrawHelp',
          isLink: false,
          name: 'Comment Faire un retrait ?',
          icon: '/images/icons/help.svg',
          actionText: 'Voir'
        }
      ],
      appsContents: [
        {
          id: 'xbetDownloadUrl',
          isLink: true,
          name: 'Télécharger 1Xbet',
          icon: '/images/icons/1xBetIco.svg',
          actionText: 'Télécharger'
        },
        {
          id: 'betwinnerDownloadUrl',
          isLink: true,
          name: 'Télécharger Betwinner',
          icon: '/images/icons/betwinner.png',
          actionText: 'Télécharger'
        },
        {
          id: 'melbetDownloadUrl',
          isLink: true,
          name: 'Télécharger Melbet',
          icon: '/images/icons/melbetIcon.svg',
          actionText: 'Télécharger'
        },
        {
          id: 'eightStarzDownloadUrl',
          isLink: true,
          name: 'Télécharger 888Starz',
          icon: '/images/icons/eightStarz.png',
          actionText: 'Télécharger'
        },
        {
          id: 'oneWinDownloadUrl',
          isLink: true,
          name: 'Télécharger OneWin',
          icon: '/images/icons/1winIcon.svg',
          actionText: 'Télécharger'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    async setAccountId() {
      const acocuntIdsPreferencesConfig = [
        {
          dataToSet: 'xbetAccountId',
          name: '1xBet'
        },
        {
          dataToSet: 'betwinnerAccountId',
          name: 'Betwinner'
        },
        {
          dataToSet: 'melbetAccountId',
          name: 'Melbet'
        },
        {
          dataToSet: 'eightStarzAccountId',
          name: '888Starz'
        },
        {
          dataToSet: 'oneWinAccountId',
          name: '1Win'
        }
      ];
      const prompt = await window.choicePrompt({
        title: 'Modifier votre identifiant',
        options: acocuntIdsPreferencesConfig,
        formatDisplay: (data) => data?.name || '',
        successText: 'Modifier'
      });
      if (!prompt.accepted || !prompt.data) return;
      this.$Events.dispatchEvent('preference_update_requested', prompt.data);
    },
    rechargeHelpClick() {
      this.requestContentDisplay(
        'Comment faire un dépot via KingRecharges',
        'rechargeVideoLink',
        'rechargeTutorialLink'
      );
    },
    withdrawHelpClick() {
      this.requestContentDisplay(
        'Comment faire des retrait via KingRecharges',
        'withdrawVideoLink',
        'withdrawTutorialLink'
      );
    },
    async requestContentDisplay(title, videoKey, tutoKey) {
      const contentToShow = await this.requestTypeOfHelpToShow(title);
      if (!contentToShow) return;
      let requestedContentLink = null;
      if (contentToShow == 'video')
        requestedContentLink =
          this.$stores.appData?.state?.data?.general?.[videoKey];
      if (contentToShow == 'tutorial')
        requestedContentLink =
          this.$stores.appData?.state?.data?.general?.[tutoKey];
      if (!requestedContentLink)
        this.$bus.emit(this.$constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Contenu non disponible',
          body: "Ce contenu n'est pas disponible pour le moment"
        });
      else {
        window.open(requestedContentLink, '_blank');
      }
    },
    async requestTypeOfHelpToShow(title) {
      const acocuntIdsPreferencesConfig = [
        {
          title: 'Guide documentaire',
          name: 'tutorial'
        },
        {
          title: 'Vidéo explicative',
          name: 'video'
        }
      ];
      const prompt = await window.choicePrompt({
        title: title,
        options: acocuntIdsPreferencesConfig,
        formatDisplay: (data) => data?.title || '',
        successText: 'Continuer'
      });
      if (!prompt.accepted || !prompt.data) return null;
      return prompt.data.name;
    }
  }
});
</script>

<style scoped>
.pattern-bg {
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='7' cy='7' r='7'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.modal-fullscreen-enter-active,
.modal-fullscreen-leave-active {
  transition: all 0.3s ease;
}

.modal-fullscreen-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.modal-fullscreen-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.3s;
}

.slider::before {
  content: '';
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

/* checked */
input:checked + .slider {
  background-color: #4f46e5; /* violet style iOS */
}

input:checked + .slider::before {
  transform: translateX(24px);
}
</style>
